export const STUDENT_INFO_TABS_CLASS = 'student-info-tabs';
export const STUDENT_INFO_ACTIVE_TAB_BG = '#703895';
export const STUDENT_INFO_ACTIVE_TAB_COLOR = '#ffffff';

export function studentInfoTabLabelStyle(active: boolean): {
  backgroundColor: string;
  color?: string;
} {
  if (active) {
    return {
      backgroundColor: STUDENT_INFO_ACTIVE_TAB_BG,
      color: STUDENT_INFO_ACTIVE_TAB_COLOR,
    };
  }
  return { backgroundColor: 'transparent' };
}
